// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_updateAgentAddressInfo(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["Agent"]);
}

var variablesConverter = {"updateAgentAddressInfoInput":{},"__root":{"input":{"r":"updateAgentAddressInfoInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"updateAgentAddressInfo_Agent":{"f":""},"updateAgentAddressInfo":{"u":"response_updateAgentAddressInfo"}}};

var wrapResponseConverterMap = {
  response_updateAgentAddressInfo: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"updateAgentAddressInfo_Agent":{"f":""},"updateAgentAddressInfo":{"u":"response_updateAgentAddressInfo"}}};

var responseConverterMap = {
  response_updateAgentAddressInfo: unwrap_response_updateAgentAddressInfo
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentAddressInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProfilePageAddressInformationForm_agent"
              }
            ],
            "type": "Agent",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentAddressInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentAddressInfo",
                "kind": "LinkedField",
                "name": "addressInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "city",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stateAbbr",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "streetAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "zip",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Agent",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c5c10fbd6001e4a194a8bc1d89784f06",
    "id": null,
    "metadata": {},
    "name": "ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation",
    "operationKind": "mutation",
    "text": "mutation ProfilePageAddressInformationForm_UpdateAgentAddressInfoMutation(\n  $input: UpdateAgentAddressInfoInput!\n) {\n  updateAgentAddressInfo(input: $input) {\n    __typename\n    ... on Agent {\n      ...ProfilePageAddressInformationForm_agent\n    }\n    ... on Node {\n      __isNode: __typename\n      __typename\n      nodeId\n    }\n  }\n}\n\nfragment ProfilePageAddressInformationForm_agent on Agent {\n  addressInfo {\n    city\n    stateAbbr\n    streetAddress\n    zip\n  }\n}\n"
  }
};
})());

var wrap_response_updateAgentAddressInfo = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateAgentAddressInfo = unwrap_response_updateAgentAddressInfo;
exports.wrap_response_updateAgentAddressInfo = wrap_response_updateAgentAddressInfo;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
